import { DeeplinkService } from './../../services/deeplink.service';
import {AfterViewInit, Component, ElementRef, NgZone, Renderer2, ViewChild} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EnvironmentsService } from 'src/app/services/enviroment.service';

@Component({
  selector: 'app-deeplink',
  templateUrl: './deeplink.component.html',
  styleUrls: ['./deeplink.component.scss'],
})
export class DeeplinkPreviewComponent {
  deepLinkRev: any;
  deepLinkRev1: any;
  tokenHifpt: any;
  link: any;
  enc: any;
  screen: any;
  dataGetLink: any;
  opened: any;
  ua = window.navigator.userAgent.toLowerCase();
  ofl: any;
  isZalo: boolean;
  direction = 'https://hi.fpt.vn';
  again: any;

  constructor(
    readonly route: ActivatedRoute,
    readonly zone: NgZone,
    readonly renderer: Renderer2
  ) {

    const url = window.location.href;
    this.deepLinkRev = 'https://staging-hi.fpt.vn/app/?' + url.split('?')[1];
    this.route.queryParamMap.subscribe((res: any) => {
      this.enc = res.params.enc;
      this.ofl = res.params.ofl;
      this.again = res.params.tryAgain;
      if (/Android/.test(navigator.userAgent) && res.params.apn) {
        this.direction = 'https://play.google.com/store/apps/details?id=com.rad.hifpt&hl=vi&pli=1&referrer=' + res.params.enc;
      } else if (/iPhone|iPad|iPod/.test(navigator.userAgent) && res.params.ibi) {
        this.direction = 'https://apps.apple.com/vn/app/hi-fpt/id1144417173?l=vi';
      } else if (res.params.link) {
        this.direction = res.params.link
      } else if (this.enc === 'link_inactive') {
        window.location.href = this.direction;
      }

    });
    this.isZalo = this.ua.includes('zalo');

  }
  openLink() {
    if (this.isZalo) {
      this.openDeeplink();
    } else {
      this.copyClipBoard();
      window.open(this.deepLinkRev + '&openWin=1');
    }
  }
  openDeeplink() {
    this.copyClipBoard();
    window.location.href = "hifpt://app?deep_link_id=https://staging-hi.fpt.vn/app?enc=" + this.enc;
    this.openOtherLink();

  }
  openOtherLink() {
    const now = Date.now();
    const timer = setTimeout(() => {
      const elapsed = Date.now() - now;
      if (elapsed < 1800) {
        window.location.href = this.direction;
      }
    }, 1500);
    document.addEventListener("visibilitychange", () => {
      console.log("visibilitychange", document.hidden);
      if (document.hidden) {
        clearTimeout(timer);
      }
    })
  }
  copyClipBoard() {
    const textArea = document.createElement("textarea");
    textArea.value = this.deepLinkRev;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      document.execCommand("copy");
      console.log("Copy fallback thành công");
    } catch (err) {
      console.error("Fallback copy thất bại", err);
    }
    document.body.removeChild(textArea);
  }
}
